import { Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { CircularProgress, Box } from '@mui/material';

import api from "../api"


function AdminRoute({children}) {
  const [isAdmin, setIsAdmin] = useState(null)

  useEffect(() => {
    getAccessLevel()
  }, [])

  const getAccessLevel = () => {
    api
      .get("/api/user/permissions/")
      .then((res) => res.data)
      .then((data) => {
        setIsAdmin(data.is_admin)
      })
      .catch((err) => console.log(err))
  }

  if (isAdmin === null) {
    return (
      <Box sx={{ display: 'flex' }}>
        <CircularProgress />
      </Box>
    )
  }

  return isAdmin ? children : <Navigate to="/unauthorized" />
}

export default AdminRoute